import { lazy, Suspense } from 'react';
import { useAuthDialog } from '@/store/authDialog';

const AuthDialog = lazy(() => import('@/components/auth/AuthDialog'));

/** Only loads the AuthDialog chunk when first opened. */
export default function AuthDialogMount() {
  const isOpen = useAuthDialog((s) => s.isOpen);
  if (!isOpen) return null;
  return (
    <Suspense fallback={null}>
      <AuthDialog />
    </Suspense>
  );
}
